import { render, staticRenderFns } from "./BaseSnackbar.vue?vue&type=template&id=809bb53a&scoped=true"
import script from "./BaseSnackbar.vue?vue&type=script&lang=js"
export * from "./BaseSnackbar.vue?vue&type=script&lang=js"
import style0 from "./BaseSnackbar.vue?vue&type=style&index=0&id=809bb53a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809bb53a",
  null
  
)

export default component.exports